// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store/modules'

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/home/index.vue'),
    meta: {title: 'Home'}
  },
  {
    // 🔑 关键：匹配 /INFP.html 这样的路径
    path: '/:type.html',
    name: 'Home',
    component: () => import('@/views/home/index.vue'),
    meta: { title: 'Home' },
    // 支持通过 props 接收参数
    props: (route) => ({
      sn: route.query.sn  
    })
  },
  {
    path: '/guidance.html',
    name: 'Guidance',
    component: () => import('@/views/home/guidance.vue'),
    meta: { title: 'Guidance' }
  },
  {
    path: '/detail.html',
    name: 'GuidanceDetail',
    component: () => import('@/views/home/detail.vue'),
    meta: { title: 'Daily Wisdom Card' }
  },
  {
    path: '/checkin.html',
    name: 'Checkin',
    component: () => import('@/views/home/checkin.vue'),
    meta: { title: 'Check-in Calendar' }
  },
  {
    path: '/soul.html',
    name: 'Soul',
    component: () => import('@/views/home/soul.vue'),
    meta: { title: 'Soul Compatibility Test' }
  },
  {
    path: '/result.html',
    name: 'Result',
    component: () => import('@/views/home/result.vue'),
    meta: { title: 'Soul Compatibility Test' }
  },
  {
    path: '/crystal.html',
    name: 'Crystal',
    component: () => import('@/views/home/crystal.vue'),
    meta: { title: ' Crystal Insight' }
  },
  {
    path: '/atlas.html',
    name: 'Atlas',
    component: () => import('@/views/atlas/index.vue'),
    meta: { title: 'Atlas' }
  },
  {
    path: '/mine.html',
    name: 'Me',
    component: () => import('@/views/mine/index.vue'),
    meta: { title: 'Me' }
  },
  {
    path: '/member.html',
    name: 'Member',
    component: () => import('@/views/mine/member.vue'),
    meta: { title: 'Member' }
  },
  {
    path: '/yearbook.html',
    name: 'Yearbook',
    component: () => import('@/views/mine/yearbook.vue'),
    meta: { title: 'My Growth Yearbook' }
  },
  {
    path: '/article.html',
    name: 'Article',
    component: () => import('@/views/mine/article.vue'),
    meta: { title: 'Article' }
  },
  {
    path: '/recover.html',
    name: 'Recover',
    component: () => import('@/views/mine/recover.vue'),
    meta: { title: 'Recover My Collection' }
  },  
  {
    path: '/concat.html',
    name: 'Concat',
    component: () => import('@/views/mine/concat.vue'),
    meta: { title: 'Contact Support' }
  },  
  {
    path: '/card.html',
    name: 'Card',
    component: () => import('@/views/card/index.vue'),
    meta: { title: 'My Personality Card' }
  },
  {
    path: '/gift.html',
    name: 'Gift',
    component: () => import('@/views/card/gift.vue'),
    meta: { title: 'Gift' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '个人神谕卡'
  
  if (to.meta.requiresAuth) {
    const isLogin = store.state.user.isLogin
    if (!isLogin) {
      window.dispatchEvent(new CustomEvent('show-login'))
      next(false)
      return
    }
  }
  
  if (to.path === '/register.html' && store.state.user.isLogin) {
    next('/')
    return
  }
  
  next()
})

export default router